import { render, staticRenderFns } from "./streamTv_About.vue?vue&type=template&id=849a939c&"
import script from "./streamTv_About.vue?vue&type=script&lang=js&"
export * from "./streamTv_About.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports